import { IconDefinition } from '@ant-design/icons-angular';

export const MkbTargetOutline: IconDefinition = {
    name: 'mkb-target',
    theme: 'outline',
    icon: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8.35" fill="#242729" stroke-width="1.3"/>
    </svg>
    
    `
}